import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find-index";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../services/apiService';
import moment from 'moment';
import { mapState } from 'vuex';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['dtwin.title'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreDtwinRuleOverviewTable',
  mixins: [userItemsPerListMixin],
  props: {
    tenantId: {
      type: Number,
      required: true
    },
    dtwinId: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      bridgeTypes: [],
      bridgeInstances: [],
      rulesList: [],
      tableOptions: defaultTableOptions,
      priorRequestOptions: null,
      serverItemsLength: 0,
      searchTerm: null,
      deletionSelection: [],
      deleteDialog: false,
      deletionInProgress: false,
      targetRuleIndex: -1,
      disableFetchOnCreatedMixin: true,
      includeVDRules: false,
      isFetchingCommandExecutions: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    detailButtonIcon: function detailButtonIcon() {
      return this.hasTwinEditPermission ? 'fa-edit' : 'fa-eye';
    },
    tableLocalized: function tableLocalized() {
      return {
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        },
        headers: [{
          sortable: false
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
          value: 'title'
        }, {
          sortable: false
        }, {
          sortable: true,
          text: this.$i18n_t('Common.digitalTwins.searchLabel'),
          value: 'dtwin.title'
        }, {
          value: 'geoFences',
          align: 'end',
          sortable: false
        }, {
          value: 'timeTriggers',
          align: 'start',
          sortable: false
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.lastTriggered'),
          value: 'lastTrigger'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.lastActions'),
          value: 'properties.actions'
        }]
      };
    }
  }),
  watch: {
    tableOptions: {
      handler: function handler() {
        this.fetchRuleList();
      },
      deep: true
    },
    dtwinId: function dtwinId() {
      this.priorRequestOptions = null;
      this.tableOptions = cloneDeep(defaultTableOptions);
    },
    searchTerm: debounce(function () {
      this.fetchRuleList();
    }, 400, {
      leading: true
    }),
    includeVDRules: function includeVDRules() {
      this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      });
    }
  },
  created: function created() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  mounted: function mounted() {
    this.fetchTwinRules();
  },
  methods: {
    get: get,
    fetchTwinRules: function fetchTwinRules() {
      var _this = this;

      var bridgeTypesPromise = this.hasTwinEditPermission ? ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes.filter(function (type) {
          // only display bridges that have instance commands
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }) : Promise.resolve([]);
      var tenantBridgePromise = this.hasTwinEditPermission ? ApiService.getBridgesForTenant(this.tenantId) : Promise.resolve([]);
      return Promise.all([bridgeTypesPromise, tenantBridgePromise, this.fetchRuleList(true)]).then(function (results) {
        _this.bridgeTypes = results[0];
        _this.bridgeInstances = results[1];
        _this.rulesList = get(results, '[2].rules');
        _this.serverItemsLength = get(results, '[2].totalCount');
      });
    },
    fetchRuleList: function fetchRuleList() {
      var _this2 = this;

      var returnOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var searchTerm = (this.searchTerm || '').trim().length > 0 ? this.searchTerm.trim() : undefined;

      if (get(this.priorRequestOptions, 'searchTerm') !== searchTerm) {
        // if the search-item is changed, reset to page 1
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'dtwin.title';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var offset = (usedPage - 1) * usedItemsPerPage;
      var newRequestOptions = {
        offset: offset,
        limit: usedItemsPerPage,
        order: {
          variable: sortItem,
          direction: sortDirection
        },
        searchTerm: searchTerm,
        includeVDRules: this.includeVDRules
      };

      if (isEqual(newRequestOptions, this.priorRequestOptions)) {
        return Promise.resolve({});
      }

      this.priorRequestOptions = newRequestOptions;
      return ApiService.digitalTwinFetchRulesOverviewList(this, this.dtwinId, newRequestOptions.offset, newRequestOptions.limit, newRequestOptions.order, newRequestOptions.searchTerm, this.includeVDRules).then(function (results) {
        if (returnOnly) {
          return results;
        }

        _this2.rulesList = results.rules;
        _this2.serverItemsLength = results.totalCount;
        return results;
      });
    },
    // fetch the command-executions on-demand one after another
    fetchCommandExecutions: function () {
      var _fetchCommandExecutions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var _loop, i;

        return regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isFetchingCommandExecutions = true;
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                  return regeneratorRuntime.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return ApiService.digitalTwinFetchRulesExecutionsOverviewList(_this3, _this3.dtwinId, _this3.rulesList[i].id).then(function (results) {
                            // it may be the case that the user switched pages and the current fetched result is not valid any more
                            if (get(_this3.rulesList, "[".concat(i, "].properties.actions"))) {
                              _this3.rulesList[i].properties.actions = results;
                              _this3.rulesList[i] = cloneDeep(_this3.rulesList[i]);
                            }
                          }).catch(function (error) {
                            console.error(error);
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop);
                });
                i = 0;

              case 3:
                if (!(i < this.rulesList.length)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.delegateYield(_loop(i), "t0", 5);

              case 5:
                i++;
                _context2.next = 3;
                break;

              case 8:
                this.isFetchingCommandExecutions = false;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchCommandExecutions() {
        return _fetchCommandExecutions.apply(this, arguments);
      }

      return fetchCommandExecutions;
    }(),
    deleteRuleToggled: function deleteRuleToggled(item) {
      if (this.deletionSelection.findIndex(function (i) {
        return i.id === item.id;
      }) >= 0) {
        this.deletionSelection = this.deletionSelection.filter(function (i) {
          return i.id !== item.id;
        });
      } else {
        var selection = cloneDeep(this.deletionSelection);
        selection.push(item);
        this.deletionSelection = selection;
      }
    },
    deleteRule: function deleteRule(index) {
      var _this4 = this;

      if (this.rulesList[index].id) {
        this.deletionInProgress = true;
        ApiService.digitalTwinDeleteRule(this, this.dtwinId, this.rulesList[index].id).then(function () {
          _this4.deleteDialog = false;
          _this4.targetRuleIndex = -1;
          pullAt(_this4.rulesList, [index]);
          _this4.rulesList = cloneDeep(_this4.rulesList);
          _this4.priorRequestOptions = null;
          _this4.tableOptions = _objectSpread(_objectSpread({}, defaultTableOptions), {}, {
            random: new Date()
          });
        }).catch(function (error) {
          if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
            _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
          } else {
            _this4.$snack(get(error, 'response.data.message'), _this4.$i18n_t('Error.unknown'), 'error');
          }
        }).finally(function () {
          _this4.deletionInProgress = false;
        });
      }
    },
    deleteSelectedRules: function deleteSelectedRules() {
      var _this5 = this;

      this.deletionInProgress = true;
      Promise.all(this.deletionSelection.map(function (item) {
        return ApiService.digitalTwinDeleteRule(_this5, _this5.dtwinId, item.id);
      })).then(function () {
        _this5.deleteDialog = false;
        _this5.deletionSelection = [];
        _this5.targetRuleIndex = -1;
        _this5.priorRequestOptions = null;
        _this5.tableOptions = _objectSpread(_objectSpread({}, defaultTableOptions), {}, {
          random: new Date()
        });
      }).catch(function (error) {
        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack(get(error, 'response.data.message'), _this5.$i18n_t('Error.unknown'), 'error');
        }
      }).finally(function () {
        _this5.deletionInProgress = false;
      });
    },
    processedRuleActions: function processedRuleActions(rule) {
      var _this6 = this;

      return (get(rule, 'properties.actions') || []).map(function (action) {
        return _this6.processRuleAction(action);
      });
    },
    processRuleAction: function processRuleAction(action) {
      var commandParts = (get(action, 'command') || '').split('.');

      if (commandParts.length < 2) {
        return {};
      }

      var bridgeInstanceId = commandParts[0];
      var command = action.command.substring(bridgeInstanceId.length + 1);
      var triggerType = action.triggerType === 'CHANGES' ? this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.changes') : this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.evaluates');
      var bridgeInstance = this.bridgeInstances.find(function (b) {
        return b.id === parseInt(bridgeInstanceId);
      });
      return {
        command: "".concat(get(bridgeInstance, 'name') || 'Unknown', ".").concat(command),
        condition: "".concat(this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ifCondition'), " ").concat(triggerType, " ").concat(this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionTo'), " ").concat(action.triggerValue),
        lastExecution: action.lastExecution ? this.localizeDate(get(action, 'lastExecution.date') || null) : null
      };
    },
    localizeDate: function localizeDate(date) {
      if (date) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(date).format('L LTS');
      }

      return this.$i18n_t('Common.noData');
    },
    updatePagination: function updatePagination(e) {
      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    baseDetailLink: function baseDetailLink(item) {
      var basePath = item.dtwin.type === 'virtualDevice' ? 'virtual-devices' : 'digitaltwin-mgmt';
      return "/".concat(basePath, "/").concat(item.dtwinId);
    },
    detailButtonClicked: function detailButtonClicked(item) {
      this.$router.push("".concat(this.baseDetailLink(item), "?ruleId=").concat(item.id), '_blank');
    }
  }
};